import { IGetItemsResult } from '../../serverApi/types/IGetItemsResult';
import { IPagedItemsParams } from '../../serverApi/types/IPage';
import { IListFetcher } from '../IListFetcher';
import { ListResult } from '../ListResult';

export class RestApiListResourceFetcher<
  TResource,
  TRequestResult extends IGetItemsResult> implements IListFetcher<TResource> {

  constructor(
    private restCall: (params: IPagedItemsParams) => Promise<TRequestResult>,
    private resultMapper: (result: TRequestResult) => TResource[]
  ) { }

  public fetchList(params: IPagedItemsParams): Promise<ListResult<TResource>> {
    return this.restCall(params)
      .then((result: TRequestResult) => {
        const startIndex = params.page ? params.page.startIndex : 0;
        return new ListResult<TResource>(this.resultMapper(result), startIndex, result.totalCount);
      });
  }

}
